export default {
  "2006": [
    "Albany (C)",
    "Armadale (C)",
    "Ashburton (S)",
    "Augusta-Margaret River (S)",
    "Bassendean (T)",
    "Bayswater (C)",
    "Belmont (C)",
    "Beverley (S)",
    "Boddington (S)",
    "Boyup Brook (S)",
    "Bridgetown-Greenbushes (S)",
    "Brookton (S)",
    "Broome (S)",
    "Broomehill (S)",
    "Bruce Rock (S)",
    "Bunbury (C)",
    "Busselton (S)",
    "Cambridge (T)",
    "Canning (C)",
    "Capel (S)",
    "Carnamah (S)",
    "Carnarvon (S)",
    "Chapman Valley (S)",
    "Chittering (S)",
    "Claremont (T)",
    "Cockburn (C)",
    "Collie (S)",
    "Coolgardie (S)",
    "Coorow (S)",
    "Corrigin (S)",
    "Cottesloe (T)",
    "Cranbrook (S)",
    "Cuballing (S)",
    "Cue (S)",
    "Cunderdin (S)",
    "Dalwallinu (S)",
    "Dandaragan (S)",
    "Dardanup (S)",
    "Denmark (S)",
    "Derby-West Kimberley (S)",
    "Donnybrook-Balingup (S)",
    "Dowerin (S)",
    "Dumbleyung (S)",
    "Dundas (S)",
    "East Fremantle (T)",
    "East Pilbara (S)",
    "Esperance (S)",
    "Exmouth (S)",
    "Fremantle (C)",
    "Geraldton (C)",
    "Gingin (S)",
    "Gnowangerup (S)",
    "Goomalling (S)",
    "Gosnells (C)",
    "Greenough (S)",
    "Halls Creek (S)",
    "Harvey (S)",
    "Irwin (S)",
    "Jerramungup (S)",
    "Joondalup (C)",
    "Kalamunda (S)",
    "Kalgoorlie/Boulder (C)",
    "Katanning (S)",
    "Kellerberrin (S)",
    "Kent (S)",
    "Kojonup (S)",
    "Kondinin (S)",
    "Koorda (S)",
    "Kulin (S)",
    "Kwinana (T)",
    "Lake Grace (S)",
    "Laverton (S)",
    "Leonora (S)",
    "Mandurah (C)",
    "Manjimup (S)",
    "Meekatharra (S)",
    "Melville (C)",
    "Menzies (S)",
    "Merredin (S)",
    "Mingenew (S)",
    "Moora (S)",
    "Morawa (S)",
    "Mosman Park (T)",
    "Mount Magnet (S)",
    "Mount Marshall (S)",
    "Mukinbudin (S)",
    "Mullewa (S)",
    "Mundaring (S)",
    "Murchison (S)",
    "Murray (S)",
    "Nannup (S)",
    "Narembeen (S)",
    "Narrogin (S)",
    "Narrogin (T)",
    "Nedlands (C)",
    "Ngaanyatjarraku (S)",
    "Northam (S)",
    "Northam (T)",
    "Northampton (S)",
    "Nungarin (S)",
    "Peppermint Grove (S)",
    "Perenjori (S)",
    "Perth (C)",
    "Pingelly (S)",
    "Plantagenet (S)",
    "Port Hedland (T)",
    "Quairading (S)",
    "Ravensthorpe (S)",
    "Rockingham (C)",
    "Roebourne (S)",
    "Sandstone (S)",
    "Serpentine-Jarrahdale (S)",
    "Shark Bay (S)",
    "South Perth (C)",
    "Stirling (C)",
    "Subiaco (C)",
    "Swan (C)",
    "Tambellup (S)",
    "Tammin (S)",
    "Three Springs (S)",
    "Toodyay (S)",
    "Trayning (S)",
    "Upper Gascoyne (S)",
    "Victoria Park (T)",
    "Victoria Plains (S)",
    "Vincent (T)",
    "WA No Usual Address",
    "WA Unincorporated",
    "Wagin (S)",
    "Wandering (S)",
    "Wanneroo (C)",
    "Waroona (S)",
    "West Arthur (S)",
    "Westonia (S)",
    "Wickepin (S)",
    "Williams (S)",
    "Wiluna (S)",
    "Wongan-Ballidu (S)",
    "Woodanilling (S)",
    "Wyalkatchem (S)",
    "Wyndham-East Kimberley (S)",
    "Yalgoo (S)",
    "Yilgarn (S)",
    "York (S)"
  ],
  "2011": [
    "Wiluna (S)",
    "Woodanilling (S)",
    "Wyalkatchem (S)",
    "Wyndham-East Kimberley (S)",
    "Yalgoo (S)",
    "Coorow (S)",
    "Serpentine-Jarrahdale (S)",
    "Shark Bay (S)",
    "Tammin (S)",
    "Three Springs (S)",
    "Wagin (S)",
    "Wandering (S)",
    "Waroona (S)",
    "West Arthur (S)",
    "Mundaring (S)",
    "Cockburn (C)",
    "Nedlands (C)",
    "Perth (C)",
    "Rockingham (C)",
    "South Perth (C)",
    "Stirling (C)",
    "Subiaco (C)",
    "Swan (C)",
    "Fremantle (C)",
    "Victoria Park (T)",
    "Joondalup (C)",
    "Wanneroo (C)",
    "Kalamunda (S)",
    "Kwinana (T)",
    "Bruce Rock (S)",
    "Bunbury (C)",
    "Busselton (S)",
    "Capel (S)",
    "Carnamah (S)",
    "Carnarvon (S)",
    "Chapman Valley (S)",
    "Bayswater (C)",
    "Belmont (C)",
    "Melville (C)",
    "Cambridge (T)",
    "Canning (C)",
    "Collie (S)",
    "Esperance (S)",
    "Exmouth (S)",
    "Geraldton-Greenough (C)",
    "Kojonup (S)",
    "Kondinin (S)",
    "Koorda (S)",
    "Kulin (S)",
    "Coolgardie (S)",
    "Murray (S)",
    "Nannup (S)",
    "Narrogin (S)",
    "Cue (S)",
    "Cunderdin (S)",
    "Dalwallinu (S)",
    "Dandaragan (S)",
    "Dardanup (S)",
    "Denmark (S)",
    "Derby-West Kimberley (S)",
    "Donnybrook-Balingup (S)",
    "Dundas (S)",
    "East Pilbara (S)",
    "Halls Creek (S)",
    "Harvey (S)",
    "Irwin (S)",
    "Jerramungup (S)",
    "Kalgoorlie/Boulder (C)",
    "Kellerberrin (S)",
    "Kent (S)",
    "Mandurah (C)",
    "Manjimup (S)",
    "Meekatharra (S)",
    "Merredin (S)",
    "Mount Marshall (S)",
    "Mullewa (S)",
    "Narrogin (T)",
    "Ngaanyatjarraku (S)",
    "Northampton (S)",
    "Nungarin (S)",
    "Plantagenet (S)",
    "Port Hedland (T)",
    "Quairading (S)",
    "Ravensthorpe (S)",
    "Roebourne (S)",
    "Toodyay (S)",
    "East Fremantle (T)",
    "Leonora (S)",
    "Wongan-Ballidu (S)",
    "Yilgarn (S)",
    "York (S)",
    "Unincorporated WA",
    // "No usual address (WA)",
    "Albany (C)",
    "Ashburton (S)",
    "Augusta-Margaret River (S)",
    "Beverley (S)",
    "Boddington (S)",
    "Boyup Brook (S)",
    "Bridgetown-Greenbushes (S)",
    "Brookton (S)",
    "Broome (S)",
    "Broomehill-Tambellup (S)",
    "Chittering (S)",
    "Corrigin (S)",
    "Cranbrook (S)",
    "Cuballing (S)",
    "Dowerin (S)",
    "Dumbleyung (S)",
    "Gingin (S)",
    "Gnowangerup (S)",
    "Goomalling (S)",
    "Katanning (S)",
    "Lake Grace (S)",
    "Laverton (S)",
    "Menzies (S)",
    "Mingenew (S)",
    "Morawa (S)",
    "Mount Magnet (S)",
    "Moora (S)",
    "Mukinbudin (S)",
    "Murchison (S)",
    "Narembeen (S)",
    "Northam (S)",
    "Perenjori (S)",
    "Pingelly (S)",
    "Sandstone (S)",
    "Trayning (S)",
    "Upper Gascoyne (S)",
    "Victoria Plains (S)",
    "Westonia (S)",
    "Wickepin (S)",
    "Williams (S)",
    "Claremont (T)",
    "Cottesloe (T)",
    "Peppermint Grove (S)",
    "Gosnells (C)",
    "Vincent (T)",
    "Armadale (C)",
    "Bassendean (T)",
    "Mosman Park (T)"
  ],
  "2016": [
    "Albany (C)",
    "Armadale (C)",
    "Ashburton (S)",
    "Augusta-Margaret River (S)",
    "Bassendean (T)",
    "Bayswater (C)",
    "Belmont (C)",
    "Beverley (S)",
    "Boddington (S)",
    "Boyup Brook (S)",
    "Bridgetown-Greenbushes (S)",
    "Brookton (S)",
    "Broome (S)",
    "Broomehill-Tambellup (S)",
    "Bruce Rock (S)",
    "Bunbury (C)",
    "Busselton (C)",
    "Cambridge (T)",
    "Canning (C)",
    "Capel (S)",
    "Carnamah (S)",
    "Carnarvon (S)",
    "Chapman Valley (S)",
    "Chittering (S)",
    "Claremont (T)",
    "Cockburn (C)",
    "Collie (S)",
    "Coolgardie (S)",
    "Coorow (S)",
    "Corrigin (S)",
    "Cottesloe (T)",
    "Cranbrook (S)",
    "Cuballing (S)",
    "Cue (S)",
    "Cunderdin (S)",
    "Dalwallinu (S)",
    "Dandaragan (S)",
    "Dardanup (S)",
    "Denmark (S)",
    "Derby-West Kimberley (S)",
    "Donnybrook-Balingup (S)",
    "Dowerin (S)",
    "Dumbleyung (S)",
    "Dundas (S)",
    "East Fremantle (T)",
    "East Pilbara (S)",
    "Esperance (S)",
    "Exmouth (S)",
    "Fremantle (C)",
    "Gingin (S)",
    "Gnowangerup (S)",
    "Goomalling (S)",
    "Gosnells (C)",
    "Greater Geraldton (C)",
    "Halls Creek (S)",
    "Harvey (S)",
    "Irwin (S)",
    "Jerramungup (S)",
    "Joondalup (C)",
    "Kalamunda (C)",
    "Kalgoorlie/Boulder (C)",
    "Karratha (C)",
    "Katanning (S)",
    "Kellerberrin (S)",
    "Kent (S)",
    "Kojonup (S)",
    "Kondinin (S)",
    "Koorda (S)",
    "Kulin (S)",
    "Kwinana (C)",
    "Lake Grace (S)",
    "Laverton (S)",
    "Leonora (S)",
    "Mandurah (C)",
    "Manjimup (S)",
    "Meekatharra (S)",
    "Melville (C)",
    "Menzies (S)",
    "Merredin (S)",
    "Migratory - Offshore - Shipping (WA)",
    "Mingenew (S)",
    "Moora (S)",
    "Morawa (S)",
    "Mosman Park (T)",
    "Mount Magnet (S)",
    "Mount Marshall (S)",
    "Mukinbudin (S)",
    "Mundaring (S)",
    "Murchison (S)",
    "Murray (S)",
    "Nannup (S)",
    "Narembeen (S)",
    "Narrogin (S)",
    "Nedlands (C)",
    "Ngaanyatjarraku (S)",
    "No usual address (WA)",
    "Northam (S)",
    "Northampton (S)",
    "Nungarin (S)",
    "Peppermint Grove (S)",
    "Perenjori (S)",
    "Perth (C)",
    "Pingelly (S)",
    "Plantagenet (S)",
    "Port Hedland (T)",
    "Quairading (S)",
    "Ravensthorpe (S)",
    "Rockingham (C)",
    "Sandstone (S)",
    "Serpentine-Jarrahdale (S)",
    "Shark Bay (S)",
    "South Perth (C)",
    "Stirling (C)",
    "Subiaco (C)",
    "Swan (C)",
    "Tammin (S)",
    "Three Springs (S)",
    "Toodyay (S)",
    "Trayning (S)",
    "Upper Gascoyne (S)",
    "Victoria Park (T)",
    "Victoria Plains (S)",
    "Vincent (C)",
    "Wagin (S)",
    "Wandering (S)",
    "Wanneroo (C)",
    "Waroona (S)",
    "West Arthur (S)",
    "Westonia (S)",
    "Wickepin (S)",
    "Williams (S)",
    "Wiluna (S)",
    "Wongan-Ballidu (S)",
    "Woodanilling (S)",
    "Wyalkatchem (S)",
    "Wyndham-East Kimberley (S)",
    "Yalgoo (S)",
    "Yilgarn (S)",
    "York (S)"
  ],
  "2021": [
    "Albany",
    "Armadale",
    "Ashburton",
    "Augusta Margaret River",
    "Bassendean",
    "Bayswater",
    "Belmont",
    "Beverley",
    "Boddington",
    "Boyup Brook",
    "Bridgetown-Greenbushes",
    "Brookton",
    "Broome",
    "Broomehill-Tambellup",
    "Bruce Rock",
    "Bunbury",
    "Busselton",
    "Cambridge",
    "Canning",
    "Capel",
    "Carnamah",
    "Carnarvon",
    "Chapman Valley",
    "Chittering",
    "Christmas Island",
    "Claremont",
    "Cockburn",
    "Cocos Islands",
    "Collie",
    "Coolgardie",
    "Coorow",
    "Corrigin",
    "Cottesloe",
    "Cranbrook",
    "Cuballing",
    "Cue",
    "Cunderdin",
    "Dalwallinu",
    "Dandaragan",
    "Dardanup",
    "Denmark",
    "Derby-West Kimberley",
    "Donnybrook-Balingup",
    "Dowerin",
    "Dumbleyung",
    "Dundas",
    "East Fremantle",
    "East Pilbara",
    "Esperance",
    "Exmouth",
    "Fremantle",
    "Gingin",
    "Gnowangerup",
    "Goomalling",
    "Gosnells",
    "Greater Geraldton",
    "Halls Creek",
    "Harvey",
    "Irwin",
    "Jerramungup",
    "Joondalup",
    "Kalamunda",
    "Kalgoorlie-Boulder",
    "Karratha",
    "Katanning",
    "Kellerberrin",
    "Kent",
    "Kojonup",
    "Kondinin",
    "Koorda",
    "Kulin",
    "Kwinana",
    "Lake Grace",
    "Laverton",
    "Leonora",
    "Mandurah",
    "Manjimup",
    "Meekatharra",
    "Melville",
    "Menzies",
    "Merredin",
    "Migratory - Offshore - Shipping (WA)",
    "Mingenew",
    "Moora",
    "Morawa",
    "Mosman Park",
    "Mount Magnet",
    "Mount Marshall",
    "Mukinbudin",
    "Mundaring",
    "Murchison",
    "Murray",
    "Nannup",
    "Narembeen",
    "Narrogin",
    "Nedlands",
    "Ngaanyatjarraku",
    "Northam",
    "Northampton",
    "Nungarin",
    "Peppermint Grove",
    "Perenjori",
    "Perth",
    "Pingelly",
    "Plantagenet",
    "Port Hedland",
    "Quairading",
    "Ravensthorpe",
    "Rockingham",
    "Sandstone",
    "Serpentine-Jarrahdale",
    "Shark Bay",
    "South Perth",
    "Stirling",
    "Subiaco",
    "Swan",
    "Tammin",
    "Three Springs",
    "Toodyay",
    "Trayning",
    "Upper Gascoyne",
    "Victoria Park",
    "Victoria Plains",
    "Vincent",
    "Wagin",
    "Wandering",
    "Wanneroo",
    "Waroona",
    "West Arthur",
    "Westonia",
    "Wickepin",
    "Williams",
    "Wiluna",
    "Wongan-Ballidu",
    "Woodanilling",
    "Wyalkatchem",
    "Wyndham-East Kimberley",
    "Yalgoo",
    "Yilgarn",
    "York",    
  ]
};



// WEBPACK FOOTER //
// ../data/wa/lgas.js